import { PageNotFound } from "./components/PageNotFound";

export default PageNotFound;
